import { Box, Link, Rating, Typography, useMediaQuery } from '@mui/material';
import React, { useRef } from 'react';
import Slider from 'react-slick';
import quotes from './../../Assets/quotes.png';
import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';

const TestimonialSlider = ({ slides }) => {
  const sliderRef = useRef(null);
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    customPaging: (i) => (
      <Box
        sx={{
          width: 19,
          height: 19,
          borderRadius: '50%',
          backgroundColor: '#d3d3d3',
          display: 'inline-block',
        }}
      />
    ),
    appendDots: (dots) => (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bottom: '-40px',
        }}
      >
        <button
          onClick={() => sliderRef.current.slickPrev()}
          style={{
            marginRight: '30px',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            fontWeight: 600,
            color: '#F59C1E',
          }}
        >
          <ArrowBackIosNew />
        </button>
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            padding: 0,
            margin: '0px !important',
            '& .slick-active div': {
              backgroundColor: '#F59C1E !important',
            },
          }}
        >
          {dots}
        </Box>
        <button
          onClick={() => sliderRef.current.slickNext()}
          style={{
            marginLeft: '30px',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            fontWeight: 600,
            color: '#F59C1E',
          }}
        >
          <ArrowForwardIos />
        </button>
      </Box>
    ),
  };
  return (
    <Slider
      ref={sliderRef}
      {...sliderSettings}
    >
      {slides.map((item, index) => (
        <Box
          key={index}
          sx={{
            paddingLeft: 2,
            display: 'flex',
            justifyContent: 'center',
            paddingY: 2,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              display: { xs: 'flex', md: 'block' },
              alignItems: { xs: 'center' },
              marginTop: { md: '30px' },
              flexDirection: { xs: 'column' },
              width: { xs: '100%', md: '870px' },
              height: { xs: '100%', md: '400px' },
            }}
          >
            <Box
              sx={{
                position: { xs: 'unset', md: 'absolute' },
                width: { xs: '60%', md: '350px' },
                top: '0',
                height: '100%',
              }}
            >
              <img
                style={{
                  borderRadius: '15px',
                  width: '100%',
                  objectFit: 'cover',
                  pointerEvents: 'none',
                  userSelect: 'none',
                }}
                src={item?.src}
                alt='avatar'
              />
            </Box>
            <Box
              sx={{
                position: { xs: 'unset', md: 'absolute' },
                left: { md: 320 },
                top: { md: '35%' },
                transform: { xs: 'unset', md: 'translateY(-50%)' },
                width: { md: '520px' },
                textAlign: { xs: 'center', md: 'left' },
                minHeight: { md: '250px' },
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                color: '#4d4352',
                background: 'rgba(255, 255, 255, 0.7)',
                boxShadow: { md: '0 4px 30px rgba(0, 0, 0, 0.1)' },
                backdropFilter: 'blur(4.5px)',
                WebkitBackdropFilter: 'blur(4.5px)',
                borderRadius: '10px',
                paddingX: { md: '30px' },
                paddingY: { md: '15px' },
                zIndex: 1,
                userSelect: 'none',
                marginTop: { xs: '10px' },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '1.5rem', md: '2rem' },
                  fontWeight: 600,
                  mb: 1,
                }}
              >
                {item?.name}
              </Typography>
              <Typography sx={{ mb: 1 }}>{item?.company_name}</Typography>
              <Typography sx={{ mb: 0.5 }}>
                {item?.role}
                {item?.district && ' - '}
                {item?.district}
                {item?.state && ', '}
                {item?.state}
              </Typography>
              {item?.video_link && (
                <Typography sx={{ mb: 2 }}>
                  <Link href={item?.video_link}>Listen now</Link>
                </Typography>
              )}

              <Typography
                sx={{
                  fontSize: { xs: '1rem', md: '1.25rem' },
                  fontWeight: 400,
                  lineHeight: '1.3',
                }}
              >
                {item?.description}
              </Typography>
            </Box>
            <Box sx={{ display: { md: 'block', xs: 'none' } }}>
              <img
                src={quotes}
                style={{
                  position: 'absolute',
                  top: '-25px',
                  right: '10px',
                }}
              />
            </Box>

            <Box
              sx={{
                position: { xs: 'unset', md: 'absolute' },
                left: { md: 320 },
                top: { md: '310px' },
                transform: { md: 'translateY(-50%)' },
                width: '200px',
                height: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#4d4352',
                background: 'rgba(255, 255, 255, 0.7)',
                boxShadow: { md: '0 4px 30px rgba(0, 0, 0, 0.1)' },
                backdropFilter: 'blur(4.5px)',
                WebkitBackdropFilter: 'blur(4.5px)',
                borderRadius: '10px',
                zIndex: 2,
                userSelect: 'none',
              }}
            >
              <Rating
                size='large'
                defaultValue={item?.rating}
                readOnly
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Slider>
  );
};

export default TestimonialSlider;
